import React, { useState } from 'react';
import ReactModal from 'react-modal';
import { uiModal, uiA, uiMerge, ui, uiButton, uiFormRow, uiCheckbox } from 'envy-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMutation } from '@apollo/client';
import { SET_CLIENT_STATE } from '../../../graphqls';

ReactModal.setAppElement('#root');

export default function Confirm({
  headerTitle,
  onConfirm,
  onTogglePublish,
  isDelete = false,
  canPublish = false,
  withPublish,
  publishedAt = '',
  popupMessage,
  buttonLabel,
  confirmedMessage,
}) {
  const [setState] = useMutation(SET_CLIENT_STATE);
  const [confirmed, setConfirmed] = useState(false);
  const handleClose = () => setState({ variables: { modalTypeShown: '' } });

  const handleConfirm = () => {
    setConfirmed(true);
    onConfirm();
  };

  return (
    <ReactModal
      isOpen
      portalClassName={uiMerge([uiModal``])}
      overlayClassName={uiMerge([uiModal`__overlay`])}
      {...ui([uiModal`__modal`, uiA`overflow-hidden`])}
    >
      {confirmed ? (
        <div {...ui([uiA`f f-column f-gap-large f-a-center f-j-center h-200`])}>
          <span {...ui([uiA`f f-column f-gap-large f-j-center`])}>
            <FontAwesomeIcon icon={['fas', 'check']} {...ui([uiA`font-size-24 color-green`])} />
            <p>{confirmedMessage}</p>
          </span>
          <button type="button" onClick={handleClose} {...ui([uiButton`--default`])}>
            <span {...ui([uiButton`__content`])}>Close</span>
          </button>
        </div>
      ) : (
        <>
          <div {...ui([uiModal`__header --alert`])}>
            <div {...ui([uiA`m-right-auto ellipsis`])}>{headerTitle}</div>
            <button type="button" onClick={handleClose} {...ui([uiButton`--clean --content-inverse`, uiA`m-right`])}>
              <span {...ui([uiButton`__content`])}>
                <FontAwesomeIcon icon={['fal', 'times']} />
              </span>
            </button>
          </div>
          <div {...ui([uiModal`__content`, uiA`m-y-small`])}>
            <p {...ui([uiFormRow``, uiA`m-x m-top`])}>{popupMessage}</p>
            {canPublish && (
              <>
                <span {...ui([uiA`f h-1 h-min-1 border-top-light w-100% m-y-large`])} />
                <label
                  {...ui([
                    uiFormRow`--full`,
                    uiA`f-gap f-a-start f-1-1-auto text-default font-weight-normal w-max-425 m-x m-y-large p-bottom:${!withPublish}`,
                  ])}
                >
                  <input type="checkbox" checked={withPublish} onChange={onTogglePublish} {...ui([uiCheckbox`--toggle`])} />
                  <div {...ui([uiFormRow`__label --free `, uiA`f f-column`])}>
                    <span>{publishedAt ? 'Republish' : 'Publish'}</span>
                    {withPublish && canPublish && (
                      <p {...ui([uiA`w-max-375 font-size-13 m-top-small`])}>
                        All changes will be published and made accessible to the public. This action cannot be reversed.
                        <span {...ui([uiA`color-red`])}>Are you sure?</span>
                      </p>
                    )}
                  </div>
                </label>
              </>
            )}
          </div>
          <div {...ui([uiModal`__footer`, uiA`m-top-auto`])}>
            <button
              onClick={handleConfirm}
              {...ui([uiButton`--red:--mint-blue:${(canPublish && withPublish) || isDelete}`, uiA`m-right m-left-auto`])}
            >
              <span
                {...ui([uiButton`__content`])}
              >{`${buttonLabel}${withPublish ? ` and ${publishedAt ? 'Republish' : 'Publish'}` : ''}`}</span>
            </button>
            <button type="button" onClick={handleClose} {...ui([uiButton`--default`, uiA`m-right`])}>
              <span {...ui([uiButton`__content`])}>Cancel</span>
            </button>
          </div>
        </>
      )}
    </ReactModal>
  );
}
